import {useEffect, useState} from "react";
import {useRecoilState} from "recoil";
import {selectedModelState, selectedModelBestState,namespaceState} from "../../../recoil/atoms";
import styles from './RoundMetric.module.css'
import useApi from "../../../services/useApi";
import LineChart from "./LineChart";
import checkChartNull from "../../../utils/checkChartNull";
import HeatmapConfusion from "./HeatmapConfusion";
import preprocessMatrixToData from '../../../utils/preprocessMatrixtoData';

export default function RoundMetric(){
  const [selectedModel, setSelectedModel]=useRecoilState(selectedModelState);
  const [selectedModelBest, setSelectedModelBest]=useRecoilState(selectedModelBestState);
  const [nsState,setNsState]=useRecoilState(namespaceState);

  const [totalTrainLossData,setTotalTrainLossData]=useState(null);
  const [totalEvalLossData,setTotalEvalLossData]=useState(null);
  const [totalAccData,setTotalAccData]=useState(null);
  const [totalMaeData,setTotalMaeData]=useState(null);
  const [totalMseData,setTotalMseData]=useState(null);
  const [totalRmseData,setTotalRmseData]=useState(null);

  const [confusionData,setConfusionData]=useState(null);

  const defaultResult = {
    "":"--"
  }

  useEffect(()=>{
    useApi.get("/ngp/fl/task/"+selectedModel.task.taskId+"/rounds?includeTask=True&namespaceId="+nsState.id).then((res)=>{
      getRoundData(res.data,res.data.rounds);
    }).catch(err=>{
      alert("Model Data가 없습니다.\n삭제되었거나 Model ID에 이상이 없는지 확인해주세요.")
    });

    useApi.get('ngp/modelreg/mm/model/v1/task/modelmetric?namespaceId='+nsState.id+'&taskId='+selectedModel.task.taskId+'&roundNum='+selectedModel.task.roundNum)
    .then(res=>{
      setConfusionData(preprocessMatrixToData(res.data))
    })
    .catch(err=>{
      setConfusionData(null)
    })

  },[selectedModel]);

  const getRoundData=(newTaskData,newRoundData)=>{

    setTotalTrainLossData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.trainingResult)return null;
          return{
            x:item.roundNum,
            y:item.trainingResult?item.trainingResult.outputs.loss:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalEvalLossData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return{
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.loss:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalAccData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.accuracy:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalMaeData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.mae:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalMseData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.mse:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })
    setTotalRmseData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.rmse:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    // setRoundDataLoading(true);
  }

  return (
    <div className={styles['wrap']}>
    {!selectedModel.task.testResult?<>
      {!checkChartNull(totalTrainLossData)&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>Train Loss</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.trainingResult?.loss}</span>
              {
              selectedModel.task.trainingResult?.loss
              >
              selectedModelBest.bestTrainLoss?.value
              ?<span className={styles['score-up']}>
                {Math.abs(selectedModel.task.trainingResult?.loss-selectedModelBest.bestTrainLoss.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
          <LineChart 
            chartData={totalTrainLossData} 
            round={selectedModel.task.roundNum}
            color="#066aff"
          />
        </div>
      }
      {!checkChartNull(totalEvalLossData)&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>Evaluation Loss</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.evaluationResult?.loss}</span>
              {
              selectedModel.task.evaluationResult?.loss
              >
              selectedModelBest.bestEvalLoss?.value
              ?<span className={styles['score-up']}>
                {Math.abs(selectedModel.task.evaluationResult?.loss-selectedModelBest.bestEvalLoss.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
          <LineChart 
            chartData={totalEvalLossData} 
            round={selectedModel.task.roundNum}
            color="#066aff"
          />
        </div>
      }
      {!checkChartNull(totalAccData)&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>Accuracy</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.evaluationResult?.accuracy}</span>
              {
              selectedModel.task.evaluationResult?.accuracy
              <
              selectedModelBest.bestAcc?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.evaluationResult?.accuracy-selectedModelBest.bestAcc.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
          <LineChart 
            chartData={totalAccData} 
            round={selectedModel.task.roundNum}
            color="#066aff"
          />
        </div>
      }
      {!checkChartNull(totalMaeData)&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>MAE</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.evaluationResult?.mae}</span>
              {
              selectedModel.task.evaluationResult?.mae
              <
              selectedModelBest.bestMae?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.evaluationResult?.mae-selectedModelBest?.bestMae.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
          <LineChart 
            chartData={totalMaeData} 
            round={selectedModel.task.roundNum}
            color="#066aff"
          />
        </div>
      }
      {!checkChartNull(totalMseData)&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>MSE</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.evaluationResult?.mse}</span>
              {
              selectedModel.task.evaluationResult?.mse
              <
              selectedModelBest.bestMse?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.evaluationResult?.mse-selectedModelBest.bestMse.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
          <LineChart 
            chartData={totalMseData} 
            round={selectedModel.task.roundNum}
            color="#066aff"
          />
        </div>
      }
      {!checkChartNull(totalRmseData)&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>RMSE</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.evaluationResult?.rmse}</span>
              {
              selectedModel.task.evaluationResult?.rmse
              <
              selectedModelBest.bestRmse?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.evaluationResult?.rmse-selectedModelBest.bestRmse.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
          <LineChart 
            chartData={totalRmseData} 
            round={selectedModel.task.roundNum}
            color="#066aff"
          />
        </div>
      }
      </>
      :
      <>
        {selectedModel.task.testResult?.loss&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>Evaluation Loss</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.testResult?.loss}</span>
              {
              selectedModel.task.testResult?.loss
              >
              selectedModelBest.bestLoss?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.testResult?.loss-selectedModelBest.bestLoss.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
        </div>}
        {selectedModel.task.testResult?.accuracy&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>Accuracy</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.testResult?.accuracy}</span>
              {
              selectedModel.task.testResult?.accuracy
              <
              selectedModelBest.bestAcc?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.testResult?.accuracy-selectedModelBest.bestAcc.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
        </div>}
        {selectedModel.task.testResult?.mae&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>MAE</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.testResult?.mae}</span>
              {
              selectedModel.task.testResult?.mae
              <
              selectedModelBest.bestMae?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.testResult?.mae-selectedModelBest.bestMae.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
        </div>}
        {selectedModel.task.testResult?.mse&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>MSE</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.testResult?.mse}</span>
              {
              selectedModel.task.testResult?.mse
              <
              selectedModelBest.bestMse?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.testResult?.mse-selectedModelBest.bestMse.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
        </div>}
        {selectedModel.task.testResult?.rmse&&
        <div className={styles['row']}>
          <div className={styles['score']}>
            <span>RMSE</span>
            <div className={styles['score-detail']}>
              <span>{selectedModel.task.testResult?.rmse}</span>
              {
              selectedModel.task.testResult?.rmse
              <
              selectedModelBest.bestRmse?.value
              ?<span className={styles['score-down']}>
                {Math.abs(selectedModel.task.testResult?.rmse-selectedModelBest.bestRmse.value).toFixed(4)}
              </span>
              :<span className={styles['score-best']}>
                Best
              </span>}
            </div>
          </div>
        </div>}
      </>
    }
    {confusionData&&<div className={styles["roundBoard-heatmap"]}>
      <div className={styles["heatmap-header"]}>
        <span>Confusion Matrix</span>
        <div className={styles["heatmap-header-info"]}>
          <span>Prediction</span>
          <span>Class</span>
        </div>
      </div>
      <HeatmapConfusion width="400" height="280" data={confusionData}/>
    </div>
    }
    </div>
  )
};